import incidentManegementConstants from 'constants/incidentManegement'

const incidentManegementSteps = (incident, isEditOrShow) => {
  const steps = [
    incidentManegementConstants.DETECTION_ENUM,
    incidentManegementConstants.INVESTIGATION_ENUM,
    incidentManegementConstants.HIGH_RISK_ENUM,
    incidentManegementConstants.AVALIATION_ENUM,
    incidentManegementConstants.LESSONS_LEARNED_ENUM,
  ]

  if (isEditOrShow && incident?.confirmed) {
    steps.splice(
      4,
      0,
      incidentManegementConstants.DETALING_ENUM,
      incidentManegementConstants.TREATMENT_ENUM,
      incidentManegementConstants.REPORTING_ENUM,
      incidentManegementConstants.COMMUNICATION_ENUM,
    )
  }

  return steps
}

export default incidentManegementSteps
